module.exports = __webpack_public_path__ + "components/flag/static/square/bg-a15efcceb94e320406ecf0bbdfe2c28c.svg";